var timeout = false,
    rtime, delta = 500


$( window ).on("load", function() {
  $('.main-loader').slideUp();
  $('body').removeClass('loading');
});

$( function( ) {

    if (window.location.hash) {
      var target = location.hash.split('#');
      setTimeout(function () {
        scroll2element($('#'+target[1]));
      }, 500);
    }


    $( document ).on( 'click', '[data-action="load-more"]', function( ) {
        var p = $( this ).closest( '.partial' ),
            caller = $( this ),
            limit = p.data( 'limit' );
        // scroll2element($(this).closest('.partial').get());

        if ( limit == null || limit < 1 ) {
            limit = 16;
        }
        caller.remove( );

        p.data( 'limit', limit + limit );

        load_partial( p, function( ) {
            caller.removeClass( 'loading' );
        } );

        return false;
    } );


     $( document ).on( 'click', '.btn-new-tab', function( ) {
         var href = $(this).data('href');
         if(href!=='#' || href!==''){
             window.open(href);
         }else{
             return false;
         }
        
    } );
   
    $(document).on('click','[data-action="filter"]',function(){
        var p = $(this).closest('.partial'), page = $(this).data('page');
        p.data('page',page);
        p.addClass('loading');
        scroll2element($(this).closest('.partial').get());
        deepLinking(p.data());
        load_partial(p);
        return false;
    });

     if($('#sidebar-navbar').length>0){
        $('body').scrollspy({ target: '#sidebar-navbar',offset:300 });

         $(window).on('activate.bs.scrollspy', function (e,obj) {
          var $url  = window.location.href.split("#");
          if(typeof ($url[0])!=='undefined' && typeof(obj.relatedTarget)!=='undefined'){
              window.history.replaceState({}, '', $url[0] + obj.relatedTarget);
          }
          
        });
        
          
     }
   
     if($('#forum-posts-navbar').length>0){
        $('body').scrollspy({ target: '#forum-posts-navbar',offset:300 });
          
     }
   
    

    if ( $( window ).scrollTop( ) > 50 ) {
        $( 'body' ).addClass( 'scrolled' );
    }

    var lastScrollTop = 0;
    $( document ).on( 'scroll', function( ) {

        _scrollTop = $( window ).scrollTop( );
        if ( _scrollTop >= 50 ) {
            $( 'body' ).addClass( 'scrolled' );
        } else {
            $( 'body' ).removeClass( 'scrolled' );
        }
    } );
    initForm( 'body' );
    
    waypoints();

} );

function waypoints( ) {

    $( '.way-point:not(.way-point-ready)' ).each( function( ) {
        $( this ).waypoint( function( ) {
            $( this.element ).addClass( 'shown' );
        }, {
            offset: '90%'
        } );
        $( this ).addClass( 'way-point-ready' );
    });
}



function initForm( target ) {
    'use strict';
    $( '.select2,select[data-plg="select2"]:visible' ).each( function( ) {
        var data = $( this ).data( );
        var _this = $( this );
        var options = {};
        if ( data.ajax ) {
            options = $.extend( false, options, {
                placeholder: data.placeholder,
                allowClear: data.allowClear || false,
                ajax: {
                    url: API + '/' + data.ajax,
                    dataType: 'json',
                    delay: 250,
                    data: function( params ) {
                        var search_for = typeof( params.term ) !== 'undefined' ? params.term : '';
                        return {
                            q: data.search + '=@' + search_for,
                            page: params.page
                        };
                    },
                    processResults: function( res, params ) {
                        params.page = params.page || 1;
                        var value_field = data.value || 'id';
                        var label_field = data.label || data.search;
                        return {
                            results: $.map( res.data, function( item ) {
                                return {
                                    all_data: item,
                                    text: item[ label_field ],
                                    id: item[ value_field ]
                                }
                            } ),
                            pagination: {
                                more: ( params.page * 30 ) < data.total_count
                            }
                        };
                    },
                    cache: true
                },
                minimumInputLength: 0
            } );
        }
        if ( $( this ).hasClass( 'select2-with-icon' ) ) {
            options = $.extend( false, options, {
                placeholder: data.placeholder,
                allowClear: data.allowClear || false,
                minimumInputLength: 0,
                templateResult: formatData,
                templateSelection: formatData
            } );
        }
        $( this ).select2( options );
    } );

}

function formatData( data ) {
    if ( !data.id ) {
        return data.text;
    }
    var $result = $(
        '<span><img src="/assets/frontend/default/img/assets/' + data.text.toLowerCase( ) + '.png"/> ' + data.text + '</span>'
    );
    return $result;
};


function changeTheme( ) {

    if( $('body').hasClass('dark') ){
        eraseCookie('theme');
    }else{
        createCookie('theme','dark');
    }
    $('body').toggleClass('dark');
    return false;
};




function actionResponseModal( msg, type, container ) {
    var $timeout = 0;

    /*if($('body').hasClass('modal-open') ){
      $('.modal').modal('hide');
      $timeout = 500;  
    }*/
    var with_ajax_modal = false;
    if ( $( '#ajaxModal:visible' ).length == 1 ) {
        with_ajax_modal = true;
        $( '#ajaxModal' ).animate( {
            opacity: 0
        }, 300 );
    }

    setTimeout( function( ) {

        var $d = '<div class="modal fade" id="responseModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">\
                <div class="modal-dialog modal-md" role="document">\
                    <div class="modal-content">\
                        <a href="#" class="close-modal" tabindex="0" onClick="$(\'#responseModal\').modal(\'hide\');return false;">\
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" viewBox="0 0 13 13" style="enable-background:new 0 0 13 13;" xml:space="preserve">\
                                <path class="st0" d="M12.9,11.7l-1.2,1.2L6.9,8.1l-4.8,4.8l-1.2-1.2l4.8-4.8L0.9,2.1l1.2-1.2l4.8,4.8l4.8-4.8l1.2,1.2L8.1,6.9 L12.9,11.7z"></path>\
                            </svg>\
                        </a>\
                        <div class="modal-body"></div>\
                    </div>\
                </div>\
            </div>';
        if ( $( '#responseModal' ).length == 0 ) {
            $( 'body' ).append( $d );
        }

        var _container = container || '';
        if ( type == 'success' ) {
            var icon = '<i class="fa fa-check-circle" aria-hidden="true"></i>';
        } else {
            var icon = '<i class="fa fa-exclamation-circle" aria-hidden="true"></i>';
        }
        var content = '<div class="alert alert-' + type + '"><h3>' + msg + '</h3></div>'
        $( '#responseModal .modal-body' ).html( content );
        $( 'body' ).addClass( 'dark-backdrop' );
        $( '#responseModal' ).modal( 'show' );
        $( '#responseModal' ).on( 'hidden.bs.modal', function( ) {
            $( '#responseModal .modal-body' ).empty( );
            $( 'body' ).removeClass( 'dark-backdrop' );
            if ( with_ajax_modal ) {
                $( '#ajaxModal' ).animate( {
                    opacity: 1
                }, 300 );
            }
        } );
    }, $timeout );

}

function loadScript( url, callback ) {
    jQuery.ajax( {
        url: url,
        dataType: 'script',
        success: callback,
        async: true
    } );
}

function load_css( t ) {
    $( 'head' ).append( '<link rel="stylesheet" href="' + t + '" type="text/css" />' );
}

function scroll2position( pos, t ) {
    $( 'html, body' ).animate( {
        scrollTop: pos
    }, t || 500 );
}

function scroll2element( el ) {
    var position = $( el ).offset( );
    var $padding = $( 'body' ).css( 'paddingTop' ).replace( 'px', '' );

    var $header_height = $( 'header' ).innerHeight();

    var y = position.top - $padding - $header_height;

    $( 'html, body' ).stop( ).animate( {
        scrollTop: y
    }, 'slow' );

}




 function deepLinking(request_data){
    //if(!$.isEmptyObject(request_data)){

    var _page= true;
    var h = '?';
    var del = '';
    for(var i in request_data){

        if( i=='page' ){
            _page = false;
        }
        if(request_data[i] == '' || i==='partial' || i==='current_url' || 
                                    i==='widgetconfig' || i==='box_image_1' ||
                                     i==='box_image_2' || i==='widgetConfig' ||  i==='content_info' ||
                                     i==='page_position' || i==='images_content_title' || i==='content_title' || i==='content_subtitle' ) {
            continue;
        }



        h += del + i+'='+request_data[i];
        del = '&';
    }

     if(_page){
         h += '&page=1';
    }

    if(h!=getQueryString()){
        history.pushState({title:h}, '' , h);
    }


    //}
}

function getQueryString(){
    if(window.location.toString().indexOf('?')>0){
        return '?' + window.location.toString().split('?')[1];
    }else{
        return '';
    }
}